// extracted by mini-css-extract-plugin
export default {"transparentButton":"SelectablePill_transparentButton__np7mY","iconSize":"SelectablePill_iconSize__YDM6q"};